import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteLecture as deleteLectureApi } from "../../../../services/dashboard/apiLectures";

export function useDeleteLecture() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteLecture,
        isLoading: isDeleting,
        error,
    } = useMutation({
        mutationFn: deleteLectureApi,
        onSuccess: () => {
            toast.success("تم حذف المحاضره بنجاح");

            queryClient.invalidateQueries({
                queryKey: ["lecturesDashboard"],
            });
        },

        onError: (error) => {
            toast.error(error.response.data.message);
        },
    });

    return { deleteLecture, isDeleting, error };
}
